// src/analytics/events.js
export const EV = Object.freeze({
  SESSION_START: "session_start",
  PAGE_VIEW: "page_view",
  SCROLL_DEPTH: "scroll_depth",
  OUTBOUND_CLICK: "outbound_click",
  HEARTBEAT: "engagement_heartbeat",
  CONSENT_UPDATE: "cookie_consent_update",

  LANDING_VIEW: "landing_view",
  CTA_CLICK: "cta_click",
  PRICING_VIEW: "pricing_view",
  PLAN_SELECT: "plan_select",
  BLOG_POST_VIEW: "blog_post_view",

  LOGIN_VIEW: "login_view",
  LOGIN_SUCCESS: "login_success",
  LOGOUT: "logout",

  UPLOAD_VIEW: "upload_view",
  UPLOAD_START: "upload_start",
  UPLOAD_SUCCESS: "upload_success",
  UPLOAD_FAIL: "upload_fail",

  VIEWER_OPEN: "viewer_open",
  VIEWER_INTERACTION: "viewer_interaction",
  VIEWER_CLOSE: "viewer_close",

  DOWNLOAD_START: "download_start",
  DOWNLOAD_SUCCESS: "download_success",
  DOWNLOAD_FAIL: "download_fail",

  OCR_VIEW: "ocr_view",
  OCR_START: "ocr_start",
  OCR_SUCCESS: "ocr_success",
  OCR_FAIL: "ocr_fail",

  CRM_VIEW: "crm_view",
  PROJECT_OPEN: "project_open",
  CATALOG_SEARCH: "catalog_search",
  CATALOG_ITEM_OPEN: "catalog_item_open",
  FILTER_CHANGE: "filters_change",

  API_ERROR: "api_error",
  UI_ERROR: "ui_error",
  PERF_VITALS: "performance_vitals",

  LEAD_MODAL_OPEN: "lead_modal_open",
  LEAD_MODAL_CLOSE: "lead_modal_close",
  LEAD_SUBMIT_SUCCESS: "lead_submit_success",
  LEAD_SUBMIT_ATTEMPT: "lead_submit_attempt",
  LEAD_SUBMIT_FAIL: "lead_submit_fail",
});